import React, { Component, useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Breadcrumb from '../../components/Breadcrumb'
import { User } from '../../core/types'
import { useLocation } from 'react-router-dom';
import LoaderButton from '../../components/loaderButton'




import {
  OwnershipComponent,
  ApplicantInfoComponent,
  ResidenceDetailsForm,
  IncomeDetailsForm,
  ConsentForm,
  DisclosureAgreementForm,
} from './components'
import './financingApplication.scss'
import { selectProductPackage } from '../../reducers'
import { fetchProductPackage } from '../products/productActions'
import { fetchOrganization } from '../../actions/organizationActions'
import { fetchPresignedS3UrlForGet } from '../../actions/configurationActions'
import { setApplicationIds } from '../../actions/refiApplicationActions'
import { selectApplicationIds } from '../../reducers/refiApplication'



/**
 * Props injected by redux via mapDispatchToProps
 */
interface FinancingApplicationProps {
  user: User
  history: any
  dispatch: any

}

interface FinancingHeaderProps {
  vehicle: {
    year: string
    make: string
    model: string
    logoUrl?: string
  }
  organization: any
  logoUrl?: string | null
  callCenterName?: string
}

const levels = [
  { label: 'Index', path: '/' },
  { label: 'People', path: '/users' },
  { label: 'Financing Application', path: '/financing/apply' },
]



export const FinancingHeader: React.FC<FinancingHeaderProps> = ({ vehicle, organization, logoUrl, callCenterName }) => {

 return (
   <div className="application-context">
          <div className="application-context__header">
            <div className="organization-info">
              <div className="organization-logo">
                <div className="logo-shield">
                   {logoUrl && (
                     <img
                                    src={logoUrl}
                                    alt="Call Center Logo"
                                    style={{ maxWidth: '200px' }}
                                  />
                   )}
                    <span>{callCenterName}</span>
                </div>
              </div>
              <div className="phone-icon">📞</div>
            </div>
            <div className="vehicle-info">
              <div>Apply for Financing with the: </div>
              <div className="car-silhouette"><span>{vehicle?.year} {vehicle?.make} {vehicle?.model}</span> 🚗</div>
            </div>
          </div>
        </div>
  )
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}



export const FinancingApplication: React.FC<FinancingApplicationProps> = ({
  user,
  history,
  dispatch,
}) => {

  const query = useQuery();
  const savedApplicationIds = useSelector(selectApplicationIds)
  const [loading, setLoading] = useState(true)
  const [logoUrl, setLogoUrl] = useState<string | null>(null)
  const [productPackage, setProductPackage] = useState(null)
  const [organization, setOrganization] = useState(null)
  const loadProductPackage = async (package_id) => {
    const productPackage = await dispatch(fetchProductPackage(package_id))
    setProductPackage(productPackage)
  }

  const loadLogo = async (logoPath: string) => {
      const logoUrl = await fetchPresignedS3UrlForGet(logoPath)
      setLogoUrl(logoUrl)
    }

  const loadOrganization = async (organization_id) => {
   const organization = await dispatch(fetchOrganization(organization_id))
   setOrganization(organization)
   loadLogo(organization.configuration.callCenterLogoPath)
  }


  useEffect(() => {
    // Get IDs from URL params first, fall back to localStorage (via Redux)
    const package_id = query.get('package_id') || savedApplicationIds.productPackageId || null;
    const organization_id = query.get('organization_id') || savedApplicationIds.organizationId || null;

    // Only proceed if we have IDs
    if (!package_id || !organization_id) {
      console.error('Missing package_id or organization_id')
      setLoading(false)
      return
    }

    // Store IDs in Redux for use throughout the application
    dispatch(setApplicationIds({
      productPackageId: package_id,
      organizationId: organization_id
    }))

    const loadData = async () => {
      setLoading(true)
      try {
        await Promise.all([
          loadProductPackage(package_id),
          loadOrganization(organization_id)
        ])
      } catch (error) {
        console.error('Error loading data:', error)
      } finally {
        setLoading(false)
      }
    }

    loadData()
  }, [])

  const getCurrentStep = () => {
    const pathname = history.location.pathname

    if (pathname.includes('/ownership')) {
      return 'ownership'
    } else if (pathname.includes('/applicant-info')) {
      return 'applicant-info'
    } else if (pathname.includes('/residence-details')) {
      return 'residence-details'
    } else if (pathname.includes('/income-details')) {
      return 'income-details'
    } else if (pathname.includes('/disclosure-agreement')) {
      return 'disclosure-agreement'
    } else if (pathname.includes('/consent')) {
      return 'consent'
    }

    return 'ownership' // default
  }

  const renderComponent = (productPackage) => {
    const currentStep = getCurrentStep()
    switch (currentStep) {
      case 'ownership':
        return <OwnershipComponent  vehicle= {productPackage?.vehicle} user={productPackage?.user} />
      case 'applicant-info':
        return <ApplicantInfoComponent vehicle= {productPackage?.vehicle} user={productPackage?.user} />
      case 'residence-details':
        return <ResidenceDetailsForm vehicle= {productPackage?.vehicle} user={productPackage?.user} />
      case 'income-details':
        return <IncomeDetailsForm vehicle= {productPackage?.vehicle} user={productPackage?.user} />
      case 'consent':
        return (
          <ConsentForm
            vehicle={productPackage?.vehicle}
            user={productPackage?.user}
          />
        )
      case 'disclosure-agreement':
        return <DisclosureAgreementForm vehicle= {productPackage?.vehicle} product_package= {productPackage}/>
      default:
        return <OwnershipComponent vehicle= {productPackage?.vehicle}/>
    }
  }

return (

    <>
      <Breadcrumb
        levels={levels.map((l) =>
          l.path === '/financing/apply' && user?.firstName
              ? {
                  ...l,
                  label: `Apply for Financing - ${user.firstName} ${user.lastName}`,
                  path: `/users/${user.id}`,
                }
              : l
          )}
        />
        <div className="financing-application">
          <FinancingHeader vehicle={productPackage?.vehicle} logoUrl={logoUrl} callCenterName={organization?.configuration.callCenterName} organization={user.organization} />
          <div className="financing-application__container">
              {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px' }}>
                  <LoaderButton isLoading={true} disabled>
                    Loading Application...
                  </LoaderButton>
                </div>
              ) : productPackage ? (
                renderComponent(productPackage)
              ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px' }}>
                  No data available
                </div>
              )}
          </div>
        </div>
      </>
    )

}

const mapStateToProps = (state) => ({
  user: selectProductPackage(state.productPackages, 1),
  organization: selectProductPackage(state.productPackages, 1),
})

export default withRouter(connect(mapStateToProps)(FinancingApplication))


